import { Selector } from "./selectors"

export const InventoryLocationSelector = Selector


// WEBPACK FOOTER //
// ./src/state/inventory/location/selectors/index.ts